import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { useResourceClickHandler } from '../ResourcePreview/hooks/useResourceClickHandler.js';
import { ResourcePreview } from '../ResourcePreview/ResourcePreview.js';
import { ResourcesPreviewUiConfigProvider } from '../ResourcePreview/resourcePreviewUiConfigContext.js';
import { LayoutGroup } from 'framer-motion';
import { IntersectionObserverAnchor } from '@fabric-app/ui/components/IntersectionObserver/IntersectionObserver';

const ResourceSimpleGridList = ({
  colorLabels,
  // resources
  resources,
  fetchNextPage,
  uiContext,
  layoutId,
  onClickResource,
  onClickFolder
}) => {
  const handleClickResource = useResourceClickHandler({
    onClickResource,
    onClickFolder
  });
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [
      /* @__PURE__ */ jsx(ResourcesPreviewUiConfigProvider, {
        uiContext,
        children: /* @__PURE__ */ jsx(LayoutGroup, {
          id: layoutId,
          children: resources.map((resource) => /* @__PURE__ */ jsx(ResourcePreview, {
            onClickResource: handleClickResource,
            resource,
            colorLabels
          }, resource.id))
        })
      }),
      /* @__PURE__ */ jsx(IntersectionObserverAnchor, {
        onIntersect: fetchNextPage,
        enabled: !!fetchNextPage,
        rootMargin: "1000px"
      })
    ]
  });
};

export { ResourceSimpleGridList };
//# sourceMappingURL=ResourceSimpleList.js.map
